import { render } from "./AddEditProducts.vue?vue&type=template&id=2d5097b2&scoped=true"
import script from "./AddEditProducts.vue?vue&type=script&lang=js"
export * from "./AddEditProducts.vue?vue&type=script&lang=js"

import "./AddEditProducts.vue?vue&type=style&index=0&id=2d5097b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5097b2"]])

export default __exports__